import { type GpTableDataRow } from '@gportal/uikit';
import { type Ref, ref, watchEffect } from 'vue';

export default <TData, TRow extends GpTableDataRow>(
  data: Ref<Array<TData>>,
  getTableRows: (data: Array<TData>) => Array<TRow>,
) => {
  const tableData = ref<Array<TRow>>([]) as Ref<Array<TRow>>;
  const selectedRows = ref<Array<TRow>>([]);

  watchEffect(() => {
    tableData.value = getTableRows(data.value);
  });

  return {
    tableData,
    selectedRows,
  };
};
